module.exports = __webpack_public_path__ + "static/favicon-0a8e556e961354d56eef6645fd964276.png";